import moment from "moment";

export default function notificationDateFormatDisplay(value) {
    if (value) {
        return moment(String(value)).format('DD - MMM - YYYY').toUpperCase()
    }
}
